import React from 'react';

import { useRegionsRequest } from './hooks';

export const TransferablesRegionSelect: React.FC<{
  id?: string;
  value?: number;
  onChange(value?: number): void;
}> = ({ id, value, onChange }) => {
  const { loading, response } = useRegionsRequest();
  const regions = response?.data ?? [];

  return (
    <select
      id={id}
      className="form-control"
      disabled={!!loading}
      value={value ?? ''}
      onChange={(event) => onChange(event.target.value ? Number(event.target.value) : undefined)}
    >
      <option value=""> - Region - </option>
      {regions.map((region) => (
        <option key={region.id} value={region.id}>
          {region.name}
        </option>
      ))}
    </select>
  );
};
